(function () {
  'use strict';
  /**
    * Common Services Modules Version - 0.5.x
    *
    * __DataStore 0.5.64 - 17 JUL 2020
    *
    * Includes support for datatable
    *
    * Internal Dependencies:
    *
    * __Utils
    *
    * External Dependencies:
    * 
    * AngularJS     1.3.0   +     - http://angularjs.org
    * jQuery        1.11.0  +     - http://jquery.com
    * lodash        3.9.3   +     - http://lodash.com
    * datatables    1.10.7  +     - http://datatables.net
    *
    *-------------------------------------------------------- */

  angular.module("lw.data.datastore", []).
    service('__DataStore', [
      '$http', '$compile', '$window', '__Utils', '__Security', '$rootScope', '$q', __DataStore
    ]).
    service('__appCommonService', [__appCommonService])
    // 17 MAR 2020
    // with help of https://stackoverflow.com/questions/16797209/how-can-i-extend-q-promise-in-angularjs-with-a-success-and-error
    .config(['$provide', function ($provide) {
      $provide.decorator('$q', ['$delegate', function ($delegate) {
        var defer = $delegate.defer;
        $delegate.defer = function () {
          var deferred = defer();
          deferred.promise.success = function (fn) {
            deferred.promise.then(function (response) {
              fn(response);
            });
            return deferred.promise;
          };
          deferred.promise.error = function (fn) {
            deferred.promise.then(null, function (response) {
              fn(response);
            });
            return deferred.promise;
          };
          return deferred;
        };
        return $delegate;
      }]);
    }]);

  function __DataStore($http, $compile, $window, __Utils, __Security, $rootScope, $q) {

    $window.__dataStorage = {
      fetch_request_counts: 1
    };
    __dataStorage.data = {};

    var requestURL = '',
      dataItemID = '',
      myFreshData = {};

    this.datatableCollection = {};

    /**
    * Reset Data Storage
    *
    * @return void
    *-------------------------------------------------------- */

    this.reset = function () {

      __dataStorage.data = {};

      __Utils.log("__DataStore:: Reset done");

    };

    /**
    * DataStore Post method
    *
    * @param requestURL {string} - url
    * @param dataObj  {object} - post data
    *     
    * @return datatable instance
    *-------------------------------------------------------- */

    this.post = function (requestURL, dataObj, options) {


      // Execution Ends
      __Utils.time("__DataStore.post");

      var dataStoreInstance = this;

      if (!requestURL) {
        __Utils.throwError("__DataStore:: URL is missing");
      }

      // generate url if its not
      if (_.isObject(requestURL) || !_.includes(requestURL, '://')) {

        requestURL = __Utils.apiURL(requestURL);

      }

      $rootScope.$broadcast('lw.datastore.event.post.started');

      __Utils.log('__DataStore:: post URL: ' + requestURL);

      if (dataObj && !_.isEmpty(dataObj)) {

        var newDataObj = {};

        if (options && options.secured == true) {

          _.forEach(dataObj, function (value, key) {
            if ((!options.unsecuredFields ||
              (_.includes(options.unsecuredFields, key) === false))
              && _.isArray(value) !== true
              && _.isObject(value) !== true) {

              if (value || value == false) {
                if (_.isBoolean(value) || _.isNumber(value)) {
                  value = String(value);
                }

                var securedValue = __Security.rsaEncrypt(value);
                // if cannot be encrypt may long a long string and needs to be concat.
                if (securedValue == false) {

                  var splitedValues = value.match(/.{1,30}/g),
                    splitedValueString = '';

                  for (var i = 0; i < splitedValues.length; i++) {

                    var securedSplitedValue = __Security.rsaEncrypt(splitedValues[i]);

                    if (securedSplitedValue == false) {

                      __Utils.throwError("Encryption Failed for { " + key + " } VALUE due to length");

                      splitedValueString = false;
                      break;

                    } else {

                      splitedValueString = splitedValueString + securedSplitedValue + '__==__';
                    }

                  }

                  securedValue = splitedValueString;
                }

                var securedKey = __Security.rsaEncrypt(key);

                if (securedKey == false) {
                  __Utils.throwError("Encryption Failed for { " + securedKey + " } KEY due to length");
                }

                newDataObj[securedKey] = securedValue;
              }
            } else {
              newDataObj[key] = value;
            }
          });

        } else {
          newDataObj = dataObj;
        }

      }

      var httpRequest = $http.post(requestURL, newDataObj);

      this.success = function (pseudoCallback) {

        httpRequest.then(function onSuccess(response) {
          $rootScope.$broadcast('lw.datastore.event.post.finished');

          var processedData = __Security.processSecuredData(response.data);
          if (processedData !== false) {
            var responseData = processedData;
          } else {
            var responseData = response.data;
          }

          __Utils.log("__DataStore:: Post request processed");

          dataStoreInstance.reset();

          pseudoCallback.call(this, responseData);

          // Execution Ends
          __Utils.timeEnd("__DataStore.post");

          // open email debug view if available
          if (responseData && responseData.__emailDebugView) {
            __Utils.openEmailDebugView(responseData.__emailDebugView);
          }

          // check if __dd 
          if (responseData && responseData.__dd) {
            __Utils.jsdd(responseData);
          }

        }, function onError(errorResponse) {

          $rootScope.$broadcast('lw.datastore.event.post.finished');
          $rootScope.$broadcast('lw.datastore.event.post.error');

          // Show the serverside errors in New Tab
          // commented as error already catches below
          /* __Utils.displayInTabWindow(_.isObject(errorResponse.data) ? errorResponse : errorResponse.data);

           __Utils.error( "__DataStore:: Ooops... Something went wrong" );

         // Execution Ends
         __Utils.timeEnd("__DataStore.post");*/

        });

        return this;

      };

      this.error = function (pseudoCallback) {

        httpRequest.catch(function onError(errorResponse) {

          var processedData = __Security.processSecuredData(errorResponse.data);

          $rootScope.$broadcast('lw.datastore.event.post.finished');
          $rootScope.$broadcast('lw.datastore.event.post.error');

          pseudoCallback.call(this, (processedData !== false) ? processedData : errorResponse.data);

          // Show the serverside errors in New Tab
          __Utils.displayInTabWindow(_.isObject(errorResponse.data) ? errorResponse : errorResponse.data);

          __Utils.error("__DataStore:: Ooops... Something went wrong");

          // Execution Ends
          __Utils.timeEnd("__DataStore.post");

        });

        return this;

      };

      return this;

    };


    /**
    * DataStore data fetch functionality
    *
    * @param string {urlID} - URL
    * @param object {options} - additional configurations items may need (eg. options.params, options.selectedTab)
    *       {
    *         params:{} // object containg addtional parameters to you want to send to the server.
    *         persist: 2 // data expiry in seconds
    *         fresh: true // need fresh data or not
    *       }
    *     
    * @return DataTable
    *-------------------------------------------------------- */
    this.fetch = function (urlID, options) {

      // Start timing now
      __Utils.time("__DataStore.fetch");

      // generate url if its not
      if (_.isObject(urlID) || !_.includes(urlID, '://')) {

        urlID = __Utils.apiURL(urlID);

      }

      $rootScope.$broadcast('lw.datastore.event.fetch.started');

      var date = new Date(),
        dateTime = date.getTime();

      // Remove expired items from DataStore
      _.each(__dataStorage.data, function (dtStoreItem, dtStoreItemKey) {

        if (dtStoreItem.data && (dtStoreItem.data.persist !== true)
          && (dateTime >= dtStoreItem.data.persist)) {

          __Utils.log("__DataStore:: Expired DataItem " + dtStoreItem.data.response_token + " discarded");

          delete __dataStorage.data[dtStoreItemKey];

        }
      });

      if (!options || !_.isObject(options)) {
        options = {};
      }

      var requestURL = urlID;

      if (options.params) {

        requestURL = urlID + '?' + $.param(options.params);

        if (_.has(options.params, 'draw')) {

          delete options.params['draw'];

        }

        urlID = urlID + '?' + $.param(options.params);

      }

      var dataItemID = __Utils.convertToSlug(urlID);

      // Check if data available for this ID
      if (_.has(__dataStorage.data, dataItemID) && __dataStorage.data[dataItemID]['data']
        && (!options.fresh || !options.persist)) {

        $rootScope.$broadcast('lw.datastore.event.fetch.finished');

        var deferred = $q.defer();

        this.dataFromCache = _.cloneDeep(__dataStorage.data[dataItemID]['data']);
        this.dataFromCache['cache'] = true;

        deferred.resolve(this.dataFromCache);

        __Utils.log("__DataStore:: Cached DataItem " + this.dataFromCache.response_token + ' - ' + requestURL);

        delete this.dataFromCache;

        // Execution Ends
        __Utils.timeEnd("__DataStore.fetch");

        return deferred.promise;

      } else { // Request for fresh fresh data from server

        var date = new Date(),
          dateTime = date.getTime(),
          resetOn = Number(dateTime + 45000); // default persist data for 45 seconds

        if (__globals.dataStore && _.has(__globals.dataStore, 'persist')) {

          var globalDataStorePersisit = __globals.dataStore.persist;

          if (_.isNumber(globalDataStorePersisit) && (globalDataStorePersisit > 0)) {

            resetOn = Number(dateTime + (globalDataStorePersisit * 1000));

          } else if (_.isBoolean(globalDataStorePersisit)) {

            resetOn = globalDataStorePersisit;

          }
        }

        // configure persist duration
        if (_.has(options, 'persist')) {

          var dsOptionPersisit = options.persist;

          if (_.isNumber(dsOptionPersisit) && (dsOptionPersisit > 0)) {

            resetOn = Number(dateTime + (dsOptionPersisit * 1000));

          } else if (_.isBoolean(dsOptionPersisit)) {

            resetOn = dsOptionPersisit;

          }
        }

        // check if dataitem has pending request
        if (__dataStorage.data[dataItemID] && __dataStorage.data[dataItemID].request_status === 'pending') {

          // Execution Ends
          __Utils.timeEnd("__DataStore.fetch");

          __Utils.warn("__DataStore:: Multiple simultaneous requests initiated!!");
          // removed throwing error for  Multiple simultaneous requests on 13 APR 2017
          // throw new Error( '__DataStore:: Multiple simultaneous requests' );
        }

        __dataStorage.data[dataItemID] = {
          'request_token': __dataStorage.fetch_request_counts,
          'request_status': 'pending'
        }

        requestURL = requestURL + (_.includes(requestURL, '?') ? '&' : '?') + "fresh=" + __dataStorage.fetch_request_counts;

        // update request count
        __dataStorage.fetch_request_counts++;

        var httpRequest = $http.get(requestURL);

        this.success = function (pseudoCallback) {

          httpRequest.then(function onSuccess(mainResponse) {

            var response = mainResponse.data;

            var processedData = __Security.processSecuredData(response);
            if (processedData !== false) {
              response = processedData;
            }

            pseudoCallback.call(this, response);

            // open email debug view if available
            if (response && response.__emailDebugView) {
              __Utils.openEmailDebugView(response.__emailDebugView);
            }

            // check if __dd
            if (response && response.__dd) {

              if (response.__dd === '__dd' || response.__pr) {

                options.fresh = true;
                // removed data item as request is force to be freshed
                delete __dataStorage.data[dataItemID];
              }

              __Utils.jsdd(response);
            }

            if (!options.fresh && resetOn && (__dataStorage.data[dataItemID] && (__dataStorage.data[dataItemID].request_token == response.response_token))) {

              // store response data
              __dataStorage.data[dataItemID]['data'] = _.cloneDeep(response);

              // store metadata
              __dataStorage.data[dataItemID]['data']['metadata'] = {
                'receivedOn': dateTime
              };

              // store dataitem expiry
              __dataStorage.data[dataItemID]['data']['persist'] = resetOn;

            }

            if (__dataStorage.data[dataItemID]) {
              // mark request as completed
              __dataStorage.data[dataItemID]['request_status'] = 'completed';
            }

            __Utils.log("__DataStore:: Fresh DataItem " + response.response_token + ' - ' + requestURL);

            // fire events
            $rootScope.$broadcast('lw.datastore.event.fetch.finished');

            // Execution Ends
            __Utils.timeEnd("__DataStore.fetch");

          }, function onError(errorResponse) {

            var processedData = __Security.processSecuredData(errorResponse.data);
            if (processedData !== false) {
              errorResponse.data = processedData;
            }

            // Show the serverside errors in New Tab
            __Utils.displayInTabWindow(_.isObject(errorResponse.data) ? errorResponse : errorResponse.data);

            __Utils.error("__DataStore:: Request for DataItem discarded due to the ServerSide error");

            // remove dataitem entry from storage
            delete __dataStorage.data[dataItemID];

            __Utils.error("__DataStore:: Ooops... Something went wrong");

            // fire events
            $rootScope.$broadcast('lw.datastore.event.fetch.finished');
            $rootScope.$broadcast('lw.datastore.event.fetch.error');

            // Execution Ends
            __Utils.timeEnd("__DataStore.fetch");

          });

          return this;
        };

        this.error = function (pseudoCallback) {

          httpRequest.catch(function onError(errorResponse) {

            var processedData = __Security.processSecuredData(errorResponse.data);
            if (processedData !== false) {
              errorResponse.data = processedData;
            }

            pseudoCallback.call(this, errorResponse.data);

            // Show the serverside errors in New Tab
            __Utils.displayInTabWindow(errorResponse);

            __Utils.error("__DataStore:: Request for DataItem discarded due to the ServerSide error");

            // remove dataitem entry from storage
            delete __dataStorage.data[dataItemID];

            __Utils.error("__DataStore:: Ooops... Something went wrong");

            // fire events
            $rootScope.$broadcast('lw.datastore.event.fetch.finished');
            $rootScope.$broadcast('lw.datastore.event.fetch.error');

            // Execution Ends
            __Utils.timeEnd("__DataStore.fetch");

          });

          return this;
        }

        this.then = function (pseudoCallback) {

          httpRequest.then(function onSuccess(mainResponse) {

            var response = mainResponse.data;

            var processedData = __Security.processSecuredData(response);
            if (processedData !== false) {
              response = processedData;
            }

            pseudoCallback.call(this, response);

            // open email debug view if available
            if (response && response.__emailDebugView) {
              __Utils.openEmailDebugView(response.__emailDebugView);
            }

            // check if __dd
            if (response && response.__dd) {

              if (response.__dd === '__dd' || response.__pr) {

                options.fresh = true;
                // removed data item as request is force to be freshed
                delete __dataStorage.data[dataItemID];
              }

              __Utils.jsdd(response);
            }

            if (!options.fresh && resetOn && (__dataStorage.data[dataItemID] && (__dataStorage.data[dataItemID].request_token == response.response_token))) {

              // store response data
              __dataStorage.data[dataItemID]['data'] = _.cloneDeep(response);

              // store metadata
              __dataStorage.data[dataItemID]['data']['metadata'] = {
                'receivedOn': dateTime
              };

              // store dataitem expiry
              __dataStorage.data[dataItemID]['data']['persist'] = resetOn;

            }

            if (__dataStorage.data[dataItemID]) {
              // mark request as completed
              __dataStorage.data[dataItemID]['request_status'] = 'completed';
            }

            __Utils.log("__DataStore:: Fresh DataItem " + response.response_token + ' - ' + requestURL);

            // fire events
            $rootScope.$broadcast('lw.datastore.event.fetch.finished');

            // Execution Ends
            __Utils.timeEnd("__DataStore.fetch");

          }).catch(function onError(errorResponse) {

            var processedData = __Security.processSecuredData(errorResponse.data);
            if (processedData !== false) {
              errorResponse.data = processedData;
            }

            // Show the serverside errors in New Tab
            __Utils.displayInTabWindow(_.isObject(errorResponse.data) ? errorResponse : errorResponse.data);

            __Utils.error("__DataStore:: Request for DataItem discarded due to the ServerSide error");

            // remove dataitem entry from storage
            delete __dataStorage.data[dataItemID];

            __Utils.error("__DataStore:: Ooops... Something went wrong");

            // fire events
            $rootScope.$broadcast('lw.datastore.event.fetch.finished');
            $rootScope.$broadcast('lw.datastore.event.fetch.error');

            // Execution Ends
            __Utils.timeEnd("__DataStore.fetch");

          });

          return this;
        };

        return this;

      }

    };

    /**
    * DataTable Custom Configuration generation based on provided data
    *
    * @param object {options} - Object  
    *                         url          (required)
    *                         scope        (required)
    *                         columnsData  (required)
    *                         dtOptions    (optional)
    *     
    * @return array
    *-------------------------------------------------------- */

    this.dtConfig = function (options, dsOptions) {

      var dataStoreInstance = this;

      if (!dsOptions || !_.isObject(dsOptions)) {

        dsOptions = {};

      }

      var dtOptionsCollection = {

        "ajax": function (data, callback, settings) {

          // for laravel 5 paginate
          data.page = (data.start / data.length) + 1;

          var drawID = data.draw ? data.draw : false,
            optionsSendToFetch = {
              params: data,
              fresh: dsOptions.fresh ? dsOptions.fresh : false
            };

          if (_.has(dsOptions, 'persist')) {
            optionsSendToFetch['persist'] = dsOptions.persist;
          }

          dataStoreInstance.fetch(options.url, optionsSendToFetch).then(function (response) {

            // open email debug view if available
            if (response && response.__emailDebugView) {
              __Utils.openEmailDebugView(response.__emailDebugView);
            }

            // check if __dd is performed
            if (response.data && response.data.__dd) {
              __Utils.jsdd(response.data);
            }

            response.draw = drawID;

            // callback for datatable after data fetched
            if (options.callbackFunction && _.isFunction(options.callbackFunction)) {
              options.callbackFunction.call(this, response);
            }

            callback(response);
          });
        },
        "drawCallback": function (settings) {
          var api = this.api(),
            $thisDataTable = api.table();
            // Add class to the datatable container if the table is empty
          if (!$thisDataTable.rows().count()) {
            $($thisDataTable.container()).addClass('lw-empty-datatable')
          }

          if (_.has($thisDataTable.columns, 'adjust') && _.has($thisDataTable.responsive, 'recalc')) {
            // responsive fix for datatable for cached datastore item 
            _.delay(function () {
              $thisDataTable.columns.adjust().responsive.recalc()
            }, 180);
          }
        },
        "columns": [],
        "createdRow": function (nRow) {

          $compile(nRow)(options.scope);

        },
        // added on 19 MAY 2016 - 0.4.0
        "responsive": {
          "details": {
            "renderer": function (api, rowIdx, columns) {
              var data = _.map(columns, function (col, i) {
                return col.hidden ?
                  '<li data-dtr-index="' + col.columnIndex + '" data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                  '<span class="dtr-title">' +
                  col.title +
                  '</span> ' +
                  '<span class="dtr-data">' +
                  col.data +
                  '</span>' +
                  '</li>' :
                  '';
              }).join('');

              return data ? $('<ul data-dtr-index="' + rowIdx + '"/>').append($compile(data)(options.scope)) : false;
            }
          }
        }
      };

      if (options.dtOptions) {

        _.assign(dtOptionsCollection, options.dtOptions);

      }

      dtOptionsCollection.columns = _.map(options.columnsData, function (dtColumnData) {

        return {

          "data": dtColumnData.name ? dtColumnData.name : null,
          "orderable": dtColumnData.orderable ? true : false,
          "render": function (subject, data, obj, settings) {

            if (!dtColumnData.name) {

              obj = subject;

            } else {

              obj.dtSubject = dtColumnData.name;

            }
            // if template given
            if (dtColumnData.template) {

              // compile data using underscore template
              return __Utils.template(dtColumnData.template, obj);

            } else {

              return obj[dtColumnData.name];
            }

          }

        };

      });

      return dtOptionsCollection;

    };

    /**
    * Initilize DataTable
    *
    * @param tableID {string} - table id
    * @param dtOptions {object} - datatable options
    * @param dsOptions {object} - datastore options
    *     
    * @return datatable instance
    *-------------------------------------------------------- */

    this.dataTable = function (tableID, dtOptions, dsOptions, callbackFunction) {

      if (callbackFunction) {
        dtOptions.callbackFunction = callbackFunction;
      }

      return $(tableID).DataTable(this.dtConfig(dtOptions, dsOptions));

    };

    /**
    * Ajax Reload DataTable
    *
    * @param dataTableInstance {object} - datatable instance
    *     
    * @return datatable instance
    *-------------------------------------------------------- */

    this.reloadDT = function (dataTableInstance) {

      dataTableInstance.ajax.reload(null, false);

      __Utils.log("__DataStore:: DataTable reloaded");

    };

  };

  function __appCommonService() {

    this.appDataTableAjaxConfig = function () {
    };

  };

})();
